// hooks/useVisualCapabilities.ts
import { useEffect, useState } from "react";

export function useVisualCapabilities() {
  const [reducedMotion, setReducedMotion] = useState(false);
  const [webglOk, setWebglOk] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mq.matches);
    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mq.addEventListener("change", handler);

    try {
      const canvas = document.createElement("canvas");
      const gl =
        canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      setWebglOk(!!gl);
    } catch {
      setWebglOk(false);
    }
    setChecked(true);

    return () => mq.removeEventListener("change", handler);
  }, []);

  return { reducedMotion, webglOk, checked };
}
